import { render, staticRenderFns } from "./PIC.vue?vue&type=template&id=0cc8a95b&"
import script from "./PIC.vue?vue&type=script&lang=js&"
export * from "./PIC.vue?vue&type=script&lang=js&"
import style0 from "./PIC.vue?vue&type=style&index=0&id=0cc8a95b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports